/**
 * Register route — alias for /login?mode=register
 *
 * Preserves compatibility with links (e.g. from /1 landing page)
 * that point to "/register". Immediately redirects to the login
 * page with the register mode search param.
 */
import { createFileRoute, Navigate } from "@tanstack/react-router";

function RegisterRedirect() {
  return <Navigate to="/login" search={{ mode: "register" }} replace />;
}

export const Route = createFileRoute("/register")({
  component: RegisterRedirect,
});
